import { gql } from "@apollo/client";

export const getCustomerDutyRequestsQuery = gql`
query {
  getCustomerDutyRequests {
    message
    response
  }
}
`;
